import { axiosInstance } from "@/config/axiosInstance";

// ? Change Status of TODO
export const changeStatusOfTODO =
  (employeeKey: string) => (data: { status: string; todoId: string }) =>
    axiosInstance
      .post(
        `/todo/status/${data.todoId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Change Status of TODO Task or Subtask
export const changeStatusOfSubtask =
  (employeeKey: string) => (data: { status: string; taskId: string }) =>
    axiosInstance
      .post(
        `/todo/task/status/${data.taskId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
